module.exports = __webpack_public_path__ + "img/logo@2x.13fa2087.png";